import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

let appVersion: string | null = null;
let initializing: Promise<void> | null = null;

const resolveVersionFromEnv = () => {
  return (
    process.env.APP_VERSION ||
    process.env.REACT_APP_VERSION ||
    process.env.GIT_COMMIT_HASH ||
    null
  );
};

export const initializeAppInfo = (): Promise<void> | void => {
  if (appVersion) return;
  if (initializing) return initializing;

  initializing = (async () => {
    try {
      if (Capacitor.getPlatform() !== "web") {
        const info = await App.getInfo();
        appVersion = info?.version ?? null;
      } else {
        appVersion = resolveVersionFromEnv();
      }
    } catch (error) {
      console.warn("アプリバージョン情報の取得に失敗しました:", error);
      appVersion = resolveVersionFromEnv();
    } finally {
      initializing = null;
    }
  })();

  return initializing;
};

export const getAppVersionTag = (): string | null => {
  if (appVersion) return appVersion;
  return resolveVersionFromEnv();
};
